import { render, staticRenderFns } from "./summitReserve.vue?vue&type=template&id=a1e946b2&scoped=true"
import script from "./summitReserve.vue?vue&type=script&lang=js"
export * from "./summitReserve.vue?vue&type=script&lang=js"
import style0 from "./summitReserve.vue?vue&type=style&index=0&id=a1e946b2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1e946b2",
  null
  
)

export default component.exports